import ApiConstant from "../../constants/api.constants";
import api from "../api";

const getAllStatus = async () => {  
    try {
        const Statuses: any = await api
        .get(ApiConstant.getAllStatus)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading get status data.', error);
         });
        const response = Statuses != null ? Statuses : null;        
        return response;
    }
    catch (e) {
        console.log('error in getStatus');
        return [];
    } 
};

const addStatus = async (complaintStatuses: any) => {
    try {
      const addStatus: any = await api
        .post(ApiConstant.createComplaintStatus , complaintStatuses)
        .then((result: any) => {
          if (result) 
            return result.data;
          else 
          return null;
        })
        .catch(function (error: any) {
          console.error("error creating status data.", error);
        });
      const response = addStatus != null ? addStatus : null;
      return response;
    } catch {
      console.log("error in add user status");
      return [];
    }
  };

  const updateStatus = async (data: any) => {
    try {
        const res: any = await api
        .put(ApiConstant.UpdateComplaintStatus, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating complaint status', error);
         });
        const response = res != null ? res : null;        
        return response;
    }
    catch
    {
        console.log('error in update complaint status');
        return [];
    }
};

const deleteStatus = async (complaintStatusId: any) => {
  try {
    const response = await api
      .delete(ApiConstant.deletecomplaintStatusId + complaintStatusId)
      .then((res: any) => {
        if (res && res.status === 200) {
          return true; 
        } else {
          return false;
        }
      })
      .catch(function (error: any) {
        console.error("Error deleting status data:", error);
        return false; 
      });

    return response;
  } catch (e) {
    console.log("Error in delete status", e);
    return false; 
  }
};

const complaintStatuses = {
    getAllStatus,
    addStatus,
    updateStatus,
    deleteStatus,
}

export default complaintStatuses;